module.exports = __webpack_public_path__ + "static/media/icon_check_human.dc21b544.svg";